export default function EpcVector() {
	return (
		<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="none">
			<path stroke="#fff" d="M11.3 8H2M7.3 12l4-4-4-4M14 3.3v9.4" />
		</svg>
	);
}
